import { useState, useEffect } from 'react';
import { Row, Button } from 'antd';
import axiosConfig from '../../utils/axiosConfig';
import type { ReactElement } from 'react';
import EnvironmentContainer from './EnvironmentContainer';
import Loading from '../loading';
import { Environments } from '../../api/environments/interface';

const EnvironmentsPage = (): ReactElement => {
  const [environments, setEnvironments] = useState<Environments[]>();
  const [isLoading, setIsLoading] = useState(true);

  const getEnvironments = () => {
    setIsLoading(true);
    axiosConfig('get', '/environments', {}, (response) => {
      const res = response as Record<'data', Environments[]>;
      setEnvironments(res.data);
      setIsLoading(false);
    });
  };

  const handleCreateTestingEnvironment = (environment: Environments) => {
    setIsLoading(true);
    axiosConfig(
      'post',
      `${environment.clientId}/environments`,
      { title: 'Testing' },
      () => {
        getEnvironments();
      }
    );
  };

  useEffect(() => {
    setIsLoading(true);
    getEnvironments();
  }, []);

  return (
    <div style={{ padding: '24px' }}>
      {environments?.length === 1 && (
        <Row
          style={{
            justifyContent: 'right',
            marginBottom: '1%'
          }}
        >
          <Button
            data-cy="Create"
            type="primary"
            onClick={() => handleCreateTestingEnvironment(environments[0])}
          >
            Add Testing Environment
          </Button>
        </Row>
      )}

      {isLoading && <Loading />}

      {!isLoading &&
        environments?.map((environment: Environments) => (
          <EnvironmentContainer
            key={environment.clientId}
            environment={environment}
          />
        ))}
    </div>
  );
};
export default EnvironmentsPage;
